import { Select, MenuItem } from "@mui/material";
import { FS } from "@plannel/utils/font-util";

/*
 * 대시보드 카드 헤더용 컴팩트 Select — 단일 출처.
 *
 * 이전엔 같은 컨트롤을 카드마다 따로 적어 값이 갈렸다(레벨용 height20/fontSize10/pr26px vs
 * TopN용 height22/fontSize11/pr28px). 여기 값을 canonical 로 고정한다. sx 로 다시 칠하지 말 것.
 *
 * options: [{ value, label, depth? }] — label 은 이미 번역된 문자열.
 *   depth 를 주면 그만큼 들여쓴다(계층 트리 표시용). 들여쓰기는 **MenuItem 의 padding** 이라
 *   선택된 값 표시(input)에는 안 묻는다 — 목록에서만 계단이 보인다.
 */
const CompactSelect = ({ value, options = [], onChange, minWidth = 72, ...rest }) => (
  <Select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    size="small"
    sx={{
      height: 22, fontSize: FS.BODY, color: "text.secondary", minWidth,
      "& .MuiSelect-select": { py: 0, pl: 1, pr: "28px !important" },
      "& .MuiSelect-icon": { right: 4 },
      "& .MuiOutlinedInput-notchedOutline": { borderColor: "divider" },
    }}
    {...rest}
  >
    {options.map((o) => (
      <MenuItem key={o.value} value={o.value}
        sx={{ fontSize: FS.BODY, minHeight: 0, py: 0.5, pl: 1 + (o.depth ?? 0) * 1.5 }}>
        {o.label}
      </MenuItem>
    ))}
  </Select>
);

export default CompactSelect;
